import { useEffect } from "react";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/lib/motion";
import { FinalCta } from "@/components/FinalCta";
import { LEGAL, BUSINESS } from "@/data/site";

export default function LegalPage({ docKey }) {
  const doc = LEGAL[docKey];
  useEffect(() => { document.title = `${doc.title} — ${BUSINESS.name}`; }, [doc.title]);

  return (
    <>
      <PageHero overline={doc.title} titleLines={[doc.title]} />
      <section className="relative pb-20">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <Reveal className="rounded-2xl border border-primary/20 bg-primary/5 p-5 text-sm text-muted-foreground">
            {doc.intro}
          </Reveal>
          <div className="mt-10 space-y-10">
            {doc.sections.map((s, i) => (
              <Reveal key={i} delay={i * 0.03}>
                <h2 className="text-xl md:text-2xl font-heading font-semibold tracking-tight">{s.h}</h2>
                <p className="mt-3 text-muted-foreground text-base leading-relaxed">{s.p}</p>
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-12 text-sm text-muted-foreground">
            Last updated {new Date().toLocaleDateString("en-IN", { year: "numeric", month: "long", day: "numeric" })}.
          </Reveal>
        </div>
      </section>
      <FinalCta />
    </>
  );
}
